export default function({ state, commit, dispatch }, query) {
  const providerId = query.id;
  const urlQuery = query.next
    ? { next: query.next, limit: 500 }
    : { limit: 500 };
  return dispatch(
    "get",
    {
      url: "/provider/" + query.id + "/lineup",
      query: urlQuery,
    },
    {
      root: true,
    }
  )
    .then((response) => {
      commit("addProviderPatients", {
        id: query.id,
        patient: response.patients,
      });
      if (response.next)
        dispatch("loadLineup", {
          ...query,
          next: response.next,
        });
    })
    .catch((error) => {
      throw error;
    });
}
